import { integer } from './integer';
import { withHttpUrl } from './withHttpUrl';

export const formatter = {
  integer,
  withHttpUrl,
};
